import { gqlPartialBauAccountDetails, gqlSystemRoleCode as SYSTEM_ROLE } from '@minecraft.graphql-types';

const isLegacyUserAbleToRestorePassword = (account: gqlPartialBauAccountDetails): boolean => {
  switch (account?.roles?.[0]?.code) {
    case SYSTEM_ROLE.TALENT:
    case SYSTEM_ROLE.PROJECT_CREATOR:
    case SYSTEM_ROLE.CASTING_DIRECTOR:
    case SYSTEM_ROLE.AGENT:
    case SYSTEM_ROLE.MANAGER:
      return Boolean(account.partialEmail || account.partialPhones?.length);
    default:
      return false;
  }
};

export default isLegacyUserAbleToRestorePassword;
